module.exports = __webpack_public_path__ + "img/home_hero_wGradient.c665cc07.png";